import { render } from "./ActivityManagement.vue?vue&type=template&id=70a8827c&scoped=true"
import script from "./ActivityManagement.vue?vue&type=script&lang=js"
export * from "./ActivityManagement.vue?vue&type=script&lang=js"

import "./ActivityManagement.vue?vue&type=style&index=0&id=70a8827c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a8827c"]])

export default __exports__